import React from 'react';
import { Step } from 'react-joyride';
import BaseTour from './BaseTour';
import { useTranslation } from 'react-i18next';

interface HabitTrackerTourProps {
    isRunning: boolean;
    onComplete: () => void;
}

const HabitTrackerTour: React.FC<HabitTrackerTourProps> = ({ isRunning, onComplete }) => {
    const { t } = useTranslation();
    const steps: Step[] = [
        {
            target: 'body',
            content: (
                <div>
                    <h3 style={{ marginBottom: '12px', fontSize: '18px', fontWeight: '600' }}>
                        {t('app_tour.habit_tracker.welcome.title')}
                    </h3>
                    <p>{t('app_tour.habit_tracker.welcome.description')}</p>
                </div>
            ),
            placement: 'center',
            disableBeacon: true,
        },
        {
            target: '[data-tour="month-calendar"]',
            content: (
                <div>
                    <h3 style={{ marginBottom: '12px', fontSize: '18px', fontWeight: '600' }}>
                        {t('app_tour.habit_tracker.month_calendar.title')}
                    </h3>
                    <p>{t('app_tour.habit_tracker.month_calendar.description')}</p>
                </div>
            ),
            placement: 'right',
            spotlightClicks: false,
        },
        {
            target: '[data-tour="daily-habits-list"]',
            content: (
                <div>
                    <h3 style={{ marginBottom: '12px', fontSize: '18px', fontWeight: '600' }}>
                        {t('app_tour.habit_tracker.daily_habits_list.title')}
                    </h3>
                    <p>{t('app_tour.habit_tracker.daily_habits_list.description')}</p>
                </div>
            ),
            placement: 'left',
        },
        {
            target: '[data-tour="add-habit-form"]',
            content: (
                <div>
                    <h3 style={{ marginBottom: '12px', fontSize: '18px', fontWeight: '600' }}>
                        {t('app_tour.habit_tracker.add_habit_form.title')}
                    </h3>
                    <p>{t('app_tour.habit_tracker.add_habit_form.description')}</p>
                </div>
            ),
            placement: 'left',
        },
        {
            target: '[data-tour="completion-chart"]',
            content: (
                <div>
                    <h3 style={{ marginBottom: '12px', fontSize: '18px', fontWeight: '600' }}>
                        {t('app_tour.habit_tracker.completion_chart.title')}
                    </h3>
                    <p>{t('app_tour.habit_tracker.completion_chart.description')}</p>
                </div>
            ),
            placement: 'top',
        },
        {
            target: '[data-tour="habits-table"]',
            content: (
                <div>
                    <h3 style={{ marginBottom: '12px', fontSize: '18px', fontWeight: '600' }}>
                        {t('app_tour.habit_tracker.habits_table.title')}
                    </h3>
                    <p>{t('app_tour.habit_tracker.habits_table.description')}</p>
                </div>
            ),
            placement: 'top',
        },
    ];

    return <BaseTour isRunning={isRunning} onComplete={onComplete} tourId="habit-tracker" steps={steps} navigateTo="/dashboard/tools/habit-tracker" />;
};

export default HabitTrackerTour;

